import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 讀取這筆物料序號目前選用的檢測種類。版本用 data.record.updatedAt。 */
export async function fetchSnProductMappingInspectionKinds(id) {
  const { data: raw } = await request.get(
    `/aftersales/sn-product-mapping/${id}/inspection-kinds`,
  );
  return parseVer4DetailResponse(raw);
}
